/** Languages written right to left. The widget ships `ar` and `he`; `fa` / `ur` are listed so
 *  adding them later needs no second change. */
const RTL_LANGUAGES = new Set(["ar", "he", "fa", "ur"]);

/** Text direction for a BCP-47 locale tag (`ar`, `ar-SA`, `pt-BR`). */
export function localeDirection(locale: string): "ltr" | "rtl" {
  const base = locale.toLowerCase().split(/[-_]/)[0];
  return RTL_LANGUAGES.has(base) ? "rtl" : "ltr";
}
